import { getSessionSignup } from '@/views/Signup/session';
import store from '@/store';

import {
  IRouterMiddleware,
  MiddlewareRoute,
  MiddlewareCallback
} from '../middleware.interface';
import MerchantService from '../../api/MerchantService';
import { app } from '@/main';

export class LoadProvidersList implements IRouterMiddleware {
  private merchantService = new MerchantService();
  private routes = new Set([
    'welcome',
    'new-onboarding',
    'bo-select-business',
    'bo-choose-loyalty-reward',
    'bo-your-store'
  ]);

  canActivate(to: MiddlewareRoute, from: MiddlewareRoute): boolean {
    return to.name ? this.routes.has(to.name) : false;
  }

  async execute(
    to: MiddlewareRoute,
    from: MiddlewareRoute,
    next: MiddlewareCallback
  ): Promise<void> {
    if ((app.$store.getters['merchant/getProvidersList'] || []).length > 0) {
      next();
      return;
    }
    // Prefers the ISO code: `GET /location/country` translates the country name
    // with the `x-lang` header, and the API answers a name it cannot resolve
    // with every provider marked as "soon".
    //
    // The name stays as the fallback because `setSessionSignup` spreads its
    // argument, so a writer that passes `countryIso2: undefined` beside a good
    // `country` overwrites the code with nothing — `SelectBusiness` and
    // `HandleOauthCallback` both read it off an optional field. Sending no
    // country at all produces the same "soon" list this fixes. The API resolves
    // either form.
    const session = getSessionSignup();
    const country = session.countryIso2 || session.country;

    const response = await this.merchantService.listProviders({
      params: { country }
    });

    const providers = response.data.providers;

    await store.dispatch('merchant/SET_PROVIDERS_LIST', providers);

    next();
  }
}
